module.exports = "#define GLSLIFY 1\n#ifdef ALPHATEST\n\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n\n#endif\n"


//////////////////
// WEBPACK FOOTER
// ./src/vendor/three/renderers/shaders/ShaderChunk/alphatest_fragment.glsl
// module id = 208
// module chunks = 0